import DeductionRuleForm from "./DeductionRuleForm";

export default DeductionRuleForm;
